import { selectLoadingAOI } from 'client/store/mapSlice/mapSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dataSensitivityLevels from 'client/utils/constants/dataSensitivityLevels';

const getAssetId = (asset) => asset?.dataproviderassigneduniqueid ?? '';
const getAssetOwnerId = (asset) => asset?.dataproviderid_fk ?? '';

const getEnhancedMeasures = (sensitiveAssets) => {
    let redactedAssetsCount = 0;
    let enhancedMeasuresCount = 0;

    const signatureParts = [];
    const assetOwnerIds = [];
    for (const asset of sensitiveAssets) {
        const id = String(getAssetId(asset));
        const assetOwnerId = String(getAssetOwnerId(asset));
        const requiresRedaction = asset?.datasensitivitylevel === dataSensitivityLevels.REQUIRES_REDACTION;
        const hasEnhancedMeasures = Boolean(asset?.enhancedmeasures);

        if (requiresRedaction) {
            redactedAssetsCount += 1;
        }
        if (hasEnhancedMeasures) {
            enhancedMeasuresCount += 1;
        }

        signatureParts.push(id);
        if (!assetOwnerIds.includes(assetOwnerId)) {
            assetOwnerIds.push(assetOwnerId);
        }
    }

    signatureParts.sort();
    const enhancedMeasuresSignature = signatureParts.join('||');

    return {
        sensitiveAssetsCount: sensitiveAssets.length,
        assetOwners: assetOwnerIds,
        redactedAssetsCount,
        enhancedMeasuresCount,
        enhancedMeasuresSignature
    };
};

export const useEnhancedMeasures = () => {
    const sensitiveAssets = useSelector(state => state?.assets?.sensitiveAssets) || [];
    const pending = useSelector(selectLoadingAOI);
    const derived = useMemo(() => getEnhancedMeasures(sensitiveAssets), [pending, sensitiveAssets]);
    return {
        sensitiveAssetsCount: derived.sensitiveAssetsCount,
        assetOwners: derived.assetOwners,
        redactedAssetsCount: derived.redactedAssetsCount,
        enhancedMeasuresCount: derived.enhancedMeasuresCount,
        enhancedMeasuresSignature: derived.enhancedMeasuresSignature
    };
};
